module.exports = __webpack_public_path__ + "static/media/icomoon.549031a4.svg";